import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    width: '100%',
  },
  content: {
    transition: 'opacity 120ms ease',
  },
  contentBusy: {
    opacity: 0.55,
  },
  overlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.65)',
    backdropFilter: 'blur(2px)',
  },
  overlayContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderRadius: theme.spacing(1),
    backgroundColor: 'rgba(255, 255, 255, 0.92)',
    boxShadow: theme.shadows[2],
  },
}));

const ModalBusyContainer = ({ busy, children, label }) => {
  const classes = useStyles();
  const { t } = useTranslation('common');

  return (
    <div className={classes.root}>
      <div className={`${classes.content} ${busy ? classes.contentBusy : ''}`} aria-busy={busy}>
        {children}
      </div>
      {busy && (
        <div className={classes.overlay}>
          <div className={classes.overlayContent}>
            <CircularProgress size={20} />
            <Typography variant="body2">{label || t('commonValues.loading', 'Loading...')}</Typography>
          </div>
        </div>
      )}
    </div>
  );
};

ModalBusyContainer.defaultProps = {
  busy: false,
  children: null,
  label: '',
};

ModalBusyContainer.propTypes = {
  busy: PropTypes.bool,
  children: PropTypes.node,
  label: PropTypes.string,
};

export default ModalBusyContainer;
